// ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
// This file was automatically generated, run pnpm gen:gql to update it
/* eslint-disable */

import type * as Types from '../../../../../../schema/public';

import { gql } from '@apollo/client';
import { OtherFreebetRewardFragmentDoc } from '../OtherFreebetRewardsQuery.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ForfeitFSRewardMutationVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
  game: Types.Scalars['ID']['input'];
  currency: Types.Scalars['String']['input'];
  inGameCurrency?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type ForfeitFSRewardMutation = { __typename?: 'Mutation', rewardsForfeitReward?: { __typename?: 'RewardsForfeitRewardPayload', rewards?: { __typename?: 'Rewards', id: string, myOtherFreebetRewards?: { __typename?: 'RewardsRewardInstanceConnection', edges?: Array<{ __typename?: 'RewardsRewardInstanceEdge', node?: { __typename?: 'RewardsRewardInstance', id: string, currency?: string, valueCurrency?: string, inGameCurrency?: string } }> } }, errors?: Array<{ __typename?: 'RewardsError', code?: number, message?: string, params?: Array<{ __typename?: 'RewardsErrorParam', name?: string, value?: string }> }> } };


export const ForfeitFSRewardMutationDocument = /*#__PURE__*/ gql`
    mutation ForfeitFSRewardMutation($id: String!, $game: ID!, $currency: String!, $inGameCurrency: String) {
  rewardsForfeitReward(input: {id: $id}) {
    rewards {
      id
      myOtherFreebetRewards(
        game: $game
        currency: $currency
        integrationCurrency: $inGameCurrency
      ) {
        edges {
          node {
            ...OtherFreebetRewardFragment
          }
        }
      }
    }
    errors {
      code
      message
      params {
        name
        value
      }
    }
  }
}
    ${OtherFreebetRewardFragmentDoc}`;
export type ForfeitFSRewardMutationMutationFn = Apollo.MutationFunction<ForfeitFSRewardMutation, ForfeitFSRewardMutationVariables>;
export function useForfeitFSRewardMutation(baseOptions?: Apollo.MutationHookOptions<ForfeitFSRewardMutation, ForfeitFSRewardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForfeitFSRewardMutation, ForfeitFSRewardMutationVariables>(ForfeitFSRewardMutationDocument, options);
      }
export type ForfeitFSRewardMutationHookResult = ReturnType<typeof useForfeitFSRewardMutation>;
export type ForfeitFSRewardMutationMutationResult = Apollo.MutationResult<ForfeitFSRewardMutation>;
export type ForfeitFSRewardMutationMutationOptions = Apollo.BaseMutationOptions<ForfeitFSRewardMutation, ForfeitFSRewardMutationVariables>;